<template>
    <div>
        <MenuAccount/>
        <IncomeStatementList/>
    </div>
</template>

<script>

import MenuAccount from '@/components/menuadmin/account/accountheader/MenuAccount.vue'
import IncomeStatementList from '@/components/menuadmin/account/accountreport/IncomeStatementList.vue'
export default {
    name:'incomeStatement',
    components:{
        MenuAccount,
        IncomeStatementList,
    },
}
</script>